<template>
    <div class="ui-timer">
        <img
            v-svg-inline
            src="@/assets/icons/ui/clock.svg"
            class="ui-timer__icon"
        />

        <span class="ui-timer__value">{{ formattedTime }}</span>
    </div>
</template>

<script setup lang="ts">
    import { defineProps, computed } from 'vue';

    const { secondsToEnd } = defineProps({
        secondsToEnd: {
            type: Number,
            required: true,
        },
    });

    const formattedTime = computed(() => {
        if (secondsToEnd <= 0) {
            return '00д. 00:00:00';
        }

        // Переводим разницу в дни, часы, минуты и секунды
        const days = Math.floor(secondsToEnd / (60 * 60 * 24));
        const hours = Math.floor((secondsToEnd / (60 * 60)) % 24);
        const minutes = Math.floor((secondsToEnd / (60)) % 60);
        const seconds = Math.floor(secondsToEnd % 60);

        const timeString = `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;

        return days > 0 ? `${days}д. ${timeString}` : timeString;
    });
</script>

<style lang="scss" scoped>
    @use './UITimer.scss' as *;
</style>
